export default __webpack_public_path__ + "ebb4dbb778de0a53d09690cd3a49681a.svg";